<template>
  <Label v-if="visible" :variant="variant" :size="size" :show-dot="false">
    {{ label }}
  </Label>
</template>

<script>
import { defineComponent, computed, getCurrentInstance } from 'vue';
import Label from '@/components/partials/Label.vue';

const VARIANT_MAP = {
  proforma: 'warning',
  additional: 'info',
  definitive: 'default',
};

export default defineComponent({
  name: 'ProposalTypeBadge',

  components: { Label },

  props: {
    proposalType: {
      type: String,
      required: true,
      validator: (value) => ['definitive', 'proforma', 'additional'].includes(value),
    },
    size: {
      type: String,
      default: 'sm',
      validator: (value) => ['default', 'sm'].includes(value),
    },
    hideDefinitive: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const instance = getCurrentInstance();
    const $t = instance.appContext.config.globalProperties.$t;

    const visible = computed(() => {
      if (props.hideDefinitive && props.proposalType === 'definitive') return false;
      return true;
    });

    const variant = computed(() => VARIANT_MAP[props.proposalType] || 'default');

    const label = computed(() => $t(`proposals.types.${props.proposalType}`) || props.proposalType);

    return { visible, variant, label };
  },
});
</script>
